import * as React from 'react';
import './styles.css';
import { Table, TableProps } from 'antd';
import NoDataYet from '@/components/NoDataYet';

export interface IBaseTableProps extends TableProps<any> {
  fullscreen?: boolean;
  fullscreenAuto?: boolean;
}

export default function BaseTable(props: IBaseTableProps) {
  const ref = React.useRef<any>(null);
  const { className, scroll, style, dataSource, ...rest } = props;

  return (
    <Table
      sticky
      ref={ref}
      dataSource={dataSource?.map((d: any, i: number) => {
        d.key = i;
        return d;
      })}
      onRow={(d, i) => ({
        onDoubleClick: () => {
          console.log(i, d);
        },
      })}
      locale={{
        emptyText: <NoDataYet />,
      }}
      className={'base-table ' + className} // + " [&_thead]:whitespace-nowrap"
      {...rest}
    />
  );
}
